// extracted by mini-css-extract-plugin
export default {"emote":"w_gvU","not-official":"GvZrY","notOfficial":"GvZrY","title":"_1_aRu","emote-pixel":"_39z1y","emotePixel":"_39z1y"};